import { motion } from 'motion/react'
import FormikForm from 'src/form/FormikForm'
import { mq, pxToRem, sizes } from 'src/theme'
import { MotionMask, MotionWrapper, Separator } from 'src/theme/styled'
import styled from 'styled-components'

import Icon from '../../Icon'
import Link from '../../Link'

export const Container = styled.hgroup<{ $color?: string }>`
  display: grid;
  grid-template-columns: calc(100% - ${pxToRem(16)} * 2);
  gap: ${pxToRem(24)};
  justify-content: center;
  padding-block-start: calc(var(--g_height__header) + ${pxToRem(80)});
  padding-block-end: ${pxToRem(24)};
  background-color: ${({ $color }) => $color};
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
    padding-block-start: calc(var(--g_height__logo) + ${pxToRem(104)});
    grid-template-columns:
      [title] 1fr
      [content] calc(100% / 3 * 2);
    align-items: center;
  }
`
export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.m375_h1}
  text-wrap: balance;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
    grid-column: title / span 1;
    grid-row: 1 / span 1;
  }
`
export const _Separator = styled(Separator)`
  @media ${mq(sizes.desktop)} {
    grid-column: title / span 2;
    grid-row: 2 / span 1;
  }
`
export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    grid-column: content / span 1;
    grid-row: 1 / span 1;
    flex-flow: row;
  }
`
export const _MotionWrapper = styled(MotionWrapper)`
  display: flex;
`

export const FormikFormWrapper = styled(motion.div)`
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    flex: 1 1 auto;
  }
`

export const _FormikForm = styled(FormikForm)`
  display: grid;
  grid-template-columns: [field] 1fr [reset] auto [submit] auto;
  align-items: center;
  gap: ${pxToRem(16)};
  flex: 1;
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  padding-inline: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    max-width: max(${pxToRem(616)}, calc(616 / 1376 * 100%));
    padding-inline: ${pxToRem(32)};
  }
`
export const Placeholder = styled.label`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 3;
  grid-column: field / span 1;
  grid-row: 1;
  transition: opacity 0.15s ease-in-out;
  color: rgba(0, 0, 0, 0.5);
  transition:
    transform 0.3s ease-in-out,
    font-size 0.3s ease-in-out;
  input:focus ~ &,
  input:not(:placeholder-shown) ~ & {
    transform: translateY(-125%);
    font-size: 0.75em;
  }
  @media ${mq(sizes.desktop)} {
    grid-template-columns: back / span 1;
    input:focus ~ &,
    input:not(:placeholder-shown) ~ & {
      transform: translateY(-150%);
    }
  }
`
export const Input = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'error',
})`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 1;
  grid-column: field / span 1;
  grid-row: 1;
  align-self: stretch;
  min-height: ${pxToRem(64)};
  margin-block: 1px;
  border: none;
  &:focus,
  &:focus-visible {
    outline: unset;
  }
  &::placeholder {
    color: transparent;
  }
  &::-ms-clear {
    display: none;
  }
  &::-webkit-search-cancel-button {
    display: none;
  }
  @media ${mq(sizes.desktop)} {
    min-height: ${pxToRem(88)};
  }
`
export const Reset = styled.button`
  position: relative;
  z-index: 2;
  grid-column: reset / span 1;
  grid-row: 1;
  display: flex;
  background: unset;
  transition:
    opacity 0.15s ease-in-out,
    visibility 0s 0s;
  input:placeholder-shown ~ & {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition:
      opacity 0.15s ease-in-out,
      visibility 0s 0.15s;
  }
`
export const ResetIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
`
export const Submit = styled.button`
  position: relative;
  z-index: 2;
  grid-column: submit / span 1;
  grid-row: 1;
  display: flex;
  background: unset;
`
export const SubmitIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`

export const BackLinkMask = styled(MotionMask)`
  align-self: end;
  @media ${mq(sizes.desktop)} {
    flex: 0 1 auto;
    margin-inline-start: auto;
    align-self: center;
  }
`

export const BackLink = styled(Link)`
  ${({ theme }) => theme.textStyles.d1440_body}
  align-items: center;
  gap: ${pxToRem(8)};
  color: ${({ theme }) => theme.colors.black};
  text-decoration: underline;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`
export const BackIcon = styled(Icon)`
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
